var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48037 9.88387H5.76091V18.0547H8.48037V9.88387ZM8.65948 7.35629C8.64183 6.55515 8.06892 5.94495 7.13861 5.94495C6.2083 5.94495 5.6001 6.55515 5.6001 7.35629C5.6001 8.14085 6.19033 8.76862 7.10331 8.76862H7.12069C8.06892 8.76862 8.65948 8.14085 8.65948 7.35629ZM18.2878 13.3698C18.2878 10.8601 16.9462 9.692 15.1567 9.692C13.7128 9.692 13.0664 10.4851 12.7054 11.0414V9.88409H9.98565C10.0215 10.6508 9.98565 18.0549 9.98565 18.0549H12.7054V13.4917C12.7054 13.2475 12.7231 13.0039 12.795 12.829C12.9915 12.3412 13.439 11.8361 14.1903 11.8361C15.1748 11.8361 15.5683 12.5853 15.5683 13.6833V18.0547H18.2877L18.2878 13.3698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin_white.2814d8377d8c95135631753fcee6181b.svg";
export { ForwardRef as ReactComponent };